import { Box } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import LoggedInAvatarButton from '../LoggedInAvatarButton'
import LanguageChooser from 'features/LanguageChooser'
import useSelectedLanguage from 'App/hooks/useSelectedLanguage'
import { StyledSecondaryActionButton } from 'App/Header/Header.styles'

const LoggedInHeader = () => {
  const { isTranslationsEnabled } = useSelectedLanguage()

  return (
    <Box
      display={'flex'}
      justifyContent={'flex-end'}
      mt={3}
      mr={2.5}
      gap={2.25}
      data-testid="loggedin-header"
    >
      <StyledSecondaryActionButton href="/sok" compact withBorder>
        <SearchIcon />
      </StyledSecondaryActionButton>

      {isTranslationsEnabled && <LanguageChooser compact withBorder />}

      <LoggedInAvatarButton withBorder />
    </Box>
  )
}

export default LoggedInHeader
